









import Vue from 'vue'
import { keyBy, throttle } from 'lodash'
import Artifacts from '@/components/artifacts/Artifacts.tsx'
import store from '@/store/index'

const throttledFetch = throttle(
  function() {
    console.log('throttled fetch of letters')
    store.dispatch({ type: 'letters/pullObjects' })
  },
  2 * 1000 /* ms */,
  { trailing: false }
)

export default Vue.extend({
  components: {
    Artifacts,
  },
  computed: {
    letter(): any {
      const members = keyBy(this.$store.getters['currentCase']!.members!.nodes || [], 'userId')

      if (this.value) {
        return this.value
      } else if (this.code) {
        const matches: any[] = this.$store.getters['letters/filterBy']({
          case_id: this.$store.getters.currentCaseId,
          code: this.code,
        })
        if (matches.length > 0) {
          const letter = matches[0]
          return { ...letter, by: members[letter.sender_id] }
        } else {
          return { body: '', by: {} } // no matching letter
        }
      } else {
        throw new Error('either value or code must be given')
      }
    },
  },
  mounted() {
    console.log('mount Display.vue')
    if (!this.noLoad) {
      console.log('load letters...')
      throttledFetch()
    } else {
      console.log(`skip loading letters because of noLoad: ${this.noLoad}`)
    }
  },
  props: {
    value: {
      type: Object,
    },
    code: {
      type: String,
    },
    noLoad: {
      type: Boolean,
      default: false,
    },
  },
})
